<script lang="ts">
    import type {ApprovalAction} from "../../interfaces/precio-item.interface";
    import NauiSlideOver from "../../naui/layout/NauiSlideOver.svelte";
    import NauiTextarea from "../../naui/atoms/NauiTextarea.svelte";
    import NauiButton from "../../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    const dispatcher = createEventDispatcher();
    export let open: boolean = false;
    export let id: number;
    export let status: ApprovalAction = {
        label: 'APROBAR',
        action: {
            label: 'Aprobado',
            value: 'aprobado'
        }
    };
    export let comment: string = null;

    function send() {
        dispatcher('send', {
            id,
            status: status.action.value,
            comment
        });
        open = false;
    }
</script>

<NauiSlideOver bind:open={open}
               title="Observaciones de la revisión">
    <div>
        <div class="box-l mb-15">
            <div class="status" class:rejected={status.action.value === 'rechazado'}>
                {status?.label}
            </div>
        </div>

        <NauiTextarea label="Observaciones"
                          bind:value={comment}/>
    </div>
    <div slot="actions" class="box">
        <NauiButton caption={status.label}
                    color="accent"
                    mode="outline"
                    className="w-100"
                    on:click={send}/>
    </div>
</NauiSlideOver>

<style>
    .status {
        background: #3F9C35;
        color: #fff;
        padding: .2rem 1rem;
        font-weight: 900;
        border-radius: 20px;
        text-transform: uppercase;
    }

    .status.rejected {
         background: #F44336;
    }
</style>